<template>
  <svg
    width="17"
    height="18"
    viewBox="0 0 17 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.5 16.5C4.35502 16.5 1 13.1456 1 9C1 4.85502 4.3544 1.5 8.5 1.5C12.645 1.5 16 4.85437 16 9C16 13.145 12.6456 16.5 8.5 16.5Z"
      stroke="#00eb1f"
      stroke-width="1.3"
      stroke-miterlimit="10"
    />
    <path
      d="M15.6001 11.3242C14.5244 9.61999 12.6244 8.48562 10.4645 8.48562C9.94789 8.48562 9.44617 8.55051 8.96704 8.67256"
      stroke="#00eb1f"
      stroke-width="1.3"
      stroke-miterlimit="10"
    />
    <path
      d="M5.797 10.6802C4.5637 9.04076 3.83203 7.00349 3.83203 4.79874C3.83203 4.20095 3.88584 3.61552 3.98882 3.04695"
      stroke="#00eb1f"
      stroke-width="1.3"
      stroke-miterlimit="10"
    />
    <path
      d="M8.52335 1.53115C7.91791 2.47497 7.5665 3.59661 7.5665 4.79875C7.5665 6.27009 8.0929 7.62084 8.96725 8.67258C7.85318 10.0128 6.17377 10.8672 4.29886 10.8672C3.12192 10.8672 2.02213 10.5304 1.09082 9.94808"
      stroke="#00eb1f"
      stroke-width="1.3"
      stroke-miterlimit="10"
    />
    <path
      d="M7.57837 5.18466C8.49113 4.90293 9.4604 4.75119 10.4644 4.75119C12.2513 4.75119 13.9282 5.23184 15.3724 6.07063"
      stroke="#00eb1f"
      stroke-width="1.3"
      stroke-miterlimit="10"
    />
    <path
      d="M13.11 9.09318C11.5152 12.352 8.16465 14.6017 4.29873 14.6017C4.03859 14.6017 3.78076 14.5915 3.52563 14.5715"
      stroke="#00eb1f"
      stroke-width="1.3"
      stroke-miterlimit="10"
    />
  </svg>
</template>

<script lang="ts">
export default {};
</script>
